// Wraps the Accordion with lazy thread-load on first expand. Clicking a
// thread routes the dashboard's drawer to that session.

import { useState, type JSX } from "react";

import { useT } from "../../i18n/index.js";
import { useProjectThreads } from "../useProjectThreads";

import { Accordion } from "./Accordion";
import { ThreadsBody } from "./ThreadsBody";

interface ConversationsAccordionProps {
  readonly projectId: number;
  readonly onOpenThread: (sessionId: string) => void;
}

export const ConversationsAccordion = ({
  projectId,
  onOpenThread,
}: ConversationsAccordionProps): JSX.Element => {
  const t = useT();
  const [opened, setOpened] = useState(false);
  const { threads, loading, error } = useProjectThreads(projectId, opened);
  return (
    <Accordion
      icon="chat"
      title={t("dashboard.accordion.conversations")}
      count={opened ? threads.length : undefined}
      onOpenChange={(open) => {
        if (open) setOpened(true);
      }}
    >
      <ThreadsBody
        threads={threads}
        loading={loading}
        error={error}
        onOpenThread={onOpenThread}
      />
    </Accordion>
  );
};
